import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './services/performance/reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import {ApolloProvider, ApolloClient, InMemoryCache, from} from "@apollo/client";
import { setContext } from '@apollo/client/link/context';
import { onError } from "@apollo/client/link/error";
import { createUploadLink } from 'apollo-upload-client';
import {AuthProvider} from "./shared/contexts/auth-context";

const authLink = setContext((_, { headers }) => {
    const token = localStorage.getItem('token');
    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        }
    }
});

const uploadLink = createUploadLink({
    uri: `${process.env.REACT_APP_API_URL}/graphql`,
});

const errorLink = onError(({ _, networkError }) => {
    if (networkError) {
        if (networkError.statusCode === 401) {
            localStorage.removeItem('token');
            window.location.href = '/';
        }
    }
});

const client = new ApolloClient({
    link: from([errorLink, authLink, uploadLink]),
    cache: new InMemoryCache({
        typePolicies: {
            Address: {
                // Generate consistent IDs for Address objects on the client side
                keyFields: ["street", "suburb", "city"],
                merge: true
            }
        }
    }),
    addTypename: false,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'cache-and-network',
            errorPolicy: 'all'
        },
        query: {
            fetchPolicy: 'network-only',
            errorPolicy: 'all'
        },
        mutate: {
            errorPolicy: 'all'
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <AuthProvider>
          <ApolloProvider client={client}>
              <BrowserRouter future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
                  <App />
              </BrowserRouter>
          </ApolloProvider>
      </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
